import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import {
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SelectItem } from '@openng/optimus-ui/api';
import { Panel } from '@openng/optimus-ui/panel';
import { Select } from '@openng/optimus-ui/select';
import { DatePicker } from '@openng/optimus-ui/datepicker';
import { InputNumber } from '@openng/optimus-ui/inputnumber';
import { Textarea } from '@openng/optimus-ui/textarea';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/core/components/base.component';
import { CommercialOutage } from 'src/app/model/commercial-services/commercial-outage';
import { InlineValidationComponent } from 'src/app/core/components/inline-validation.component';

@Component({
  selector: 'app-commercial-outage-form',
  templateUrl: './commercial-outage-form.component.html',
  styleUrls: ['./commercial-outage-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    Panel,
    Select,
    DatePicker,
    InputNumber,
    Textarea,
    TranslatePipe,
    InlineValidationComponent,
  ],
})
export class CommercialOutageFormComponent extends BaseComponent {
  readonly form = input<UntypedFormGroup | undefined>();
  readonly outage = input<CommercialOutage | null>(null);
  readonly availableFacilities = input<SelectItem[]>([]);
  readonly availableAors = input<SelectItem[]>([]);
  readonly availableOperatingAreas = input<SelectItem[]>([]);
  readonly availableMarketAreas = input<SelectItem[]>([]);
  readonly writeAccess = input(false);
  readonly operatingAreaChanged = output<string | null>();
  readonly facilitySelected = output<string | null>();
  readonly facilityFiltersChanged = output<void>();
}
